/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Contribution_SectionInputs */

const fr_settings_contribution_section = /** @type {(inputs: Settings_Contribution_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace contribution`)
};

const en_settings_contribution_section = /** @type {(inputs: Settings_Contribution_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribution area`)
};

/**
* | output |
* | --- |
* | "Contribution area" |
*
* @param {Settings_Contribution_SectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_contribution_section = /** @type {((inputs?: Settings_Contribution_SectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Contribution_SectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_contribution_section(inputs)
	return en_settings_contribution_section(inputs)
});